<template>
<div class="ew-page">
  <navbar-dashboard name="Mis Envíos"></navbar-dashboard>

  <div class="ew-page__body">
    <b-tabs pills class="ew-tabs">
      <b-tab title="Envíos Web" active>

        <div class="ew-toolbar ew-toolbar--end">
          <router-link class="ew-btn-primary" to="/dashboard/shipment/new">Nuevo envío</router-link>
        </div>

        <b-alert :show="dismissCountDown"
              dismissible
              variant="success"
              @dismissed="dismissCountDown=0"
              @dismiss-count-down="countDownChanged"
              class="ew-alert">
          {{message}}
        </b-alert>

        <section class="ew-card">
          <div class="ew-filters">
            <span class="ew-filters__label"><ph-icon name="funnel" />Filtrar búsqueda por</span>
            <form class="ew-filters__row" @submit.prevent>
              <input
                type="text"
                class="ew-input ew-filters__keyword"
                placeholder="Palabra clave..."
                v-model="searchByKeywordCriteria"
                @keyup.enter="filterShipments(searchByKeywordCriteria)"
              >

              <select class="ew-select" v-model.trim="selectedService" @change="filterShipmentsByCarriersServices(selectedService)">
                <option selected>Servicios</option>
                <option v-for="c in availableCarriers" :value="c" :key="c">{{ carrierAndServiceCarrier(c) }}</option>
              </select>

              <select class="ew-select" v-model.trim="guideStatusFilter" @change="filterShipmentsByGuideStatus(guideStatusFilter)">
                <option value="all">Estatus de pago</option>
                <option value="false">Guía sin pago</option>
                <option value="true">Pagado</option>
              </select>
            </form>

            <div class="ew-filters__badges" v-if="filter.length > 0">
              <span class="ew-badge" v-for="(c, i) in filter" :key="i">
                {{printBadge(c)}}
                <ph-icon name="x" @click.native="deletebadg(i)" />
              </span>
            </div>

            <div class="ew-bulk-actions">
              <button type="button" class="ew-btn-outline" @click="pmeayntsMany()" :disabled="!(selected.length > 0)" :class="{ 'is-active': selected.length > 0 }">Pagar</button>
              <button type="button" class="ew-btn-outline" @click="duplicate()" :disabled="!(selected.length > 0)" :class="{ 'is-active': selected.length > 0 }">Duplicar</button>
              <button type="button" class="ew-btn-outline" @click="deleteMany()" :disabled="!(selected.length > 0)" :class="{ 'is-active': selected.length > 0 }">Eliminar</button>
            </div>
          </div>

          <div class="table-responsive">
            <div class="ew-loading" v-if="dataLoading">
              <span class="ew-spinner"></span>
              <p class="ew-loading-text">Cargando envíos…</p>
            </div>
            <table class="ew-table" v-else-if="shipments.docs && shipments.docs.length > 0">
              <thead>
                <tr>
                  <th scope="col">
                    <input type="checkbox" class="ew-checkbox" v-model="selectAll">
                  </th>
                  <th scope="col">Destino</th>
                  <th scope="col">Servicio</th>
                  <th scope="col">N° de guía</th>
                  <th scope="col">Estatus guía</th>
                  <th scope="col">Total</th>
                  <th scope="col">Guía</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(s, i) in shipments.docs"
                  v-bind:key="i"
                  @click="gotoShipmentDetails(s._id)"
                  class="ew-table-row-clickable"
                >
                  <td>
                    <input type="checkbox" class="ew-checkbox" v-model="selected" :value="s" @click.stop>
                  </td>
                  <td>{{ s.destination_direction.full_name }}</td>
                  <td>{{ localCapitalize(s.selected_service.carrier_service_name)}}</td>
                  <td>{{numberGuide(s.number_guide)}}</td>
                  <td>{{obtenerStatus(s)}}</td>
                  <td class="ew-table__amount" :class="{'is-pending': !s.status, 'is-paid': s.status}">
                    <small>{{ s.selected_service.currency }}</small> {{ s.selected_service.total_amount }}
                  </td>
                  <td>
                    <a @click.stop :href="downloadTracking(s)" download :class="{disabled: !s.status}" target="_blank" class="ew-table__pdf-link">
                        <img src="@/assets/images/pdf-icon.svg" v-if="s.status" class="ew-icon-pdf" alt="Descargar guía">
                        <img src="@/assets/images/pdf-icon-grey.svg" v-else class="ew-icon-pdf" alt="Guía aún no disponible">
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="ew-empty" v-else>
              <ph-icon name="package" />
              <p class="ew-empty__title">Aún no tienes envíos</p>
              <p class="ew-empty__text">Cuando generes tu primer envío, aparecerá aquí.</p>
              <router-link class="ew-btn-primary" to="/dashboard/shipment/new">Crear mi primer envío</router-link>
            </div>
          </div>

          <div class="ew-pagination" v-if="shipments.docs && shipments.docs.length > 0">
            <button class="ew-pagination__btn" @click="previousPage">Anterior</button>
            <button
              class="ew-pagination__btn"
              @click="goToPage(p)"
              v-for="p in availablePages(shipments.page)"
              :key="p"
              :class="{'is-active': shipments.page === p }"
            >{{ p }}</button>
            <button class="ew-pagination__btn" @click="nextPage">Siguiente</button>
          </div>
        </section>

        <b-modal ref="myModalRef" id="modalcenter" centered title="Información preventiva" hide-footer modal-class="ew-modal">
            <p class="ew-modal__text">Has seleccionado un envío que ya ha sido pagado; te invitamos a desmarcar las casillas correspondientes para poder continuar con tu operación.</p>
            <div class="ew-modal__actions">
              <button class="ew-btn-primary" @click="hideModal">Entendido</button>
            </div>
        </b-modal>
      </b-tab>

      <b-tab title="E-Commerce">
        <div class="ew-toolbar ew-toolbar--end">
          <router-link class="ew-btn-primary" to="/dashboard/shipment/new">Nuevo envío</router-link>
        </div>

        <section class="ew-card">
          <div class="ew-filters">
            <form class="ew-filters__row" @submit.prevent>
              <input type="text" class="ew-input ew-filters__keyword" placeholder="Palabra clave..." v-model="key">
            </form>
          </div>

          <div class="table-responsive">
            <table class="ew-table" v-if="marketplaceList && marketplaceList.length > 0">
              <thead>
                <tr>
                  <th scope="col">Nombre</th>
                  <th scope="col">Destino</th>
                  <th scope="col">Servicio</th>
                  <th scope="col">N° de guía</th>
                  <th scope="col">Estatus guía</th>
                  <th scope="col">Total</th>
                  <th scope="col">Guía</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(s, i) in marketplaceList" v-bind:key="i" @click="gotoShipmentEcommerce(i)" class="ew-table-row-clickable">
                  <td @click.stop>{{ s.destination_direction.full_name }}</td>
                  <td @click.stop>{{ s.destination_direction.address }}</td>
                  <td @click.stop>--</td>
                  <td @click.stop>--</td>
                  <td @click.stop>--</td>
                  <td @click.stop>--</td>
                  <td class="ew-table__link">Generar guía</td>
                  </tr>
              </tbody>
            </table>
            <div class="ew-empty" v-else>
              <ph-icon name="package" />
              <p class="ew-empty__title">Sin pedidos de e-commerce por ahora</p>
              <p class="ew-empty__text">Cuando llegue un pedido de tu tienda conectada, aparecerá aquí.</p>
            </div>
          </div>
        </section>

        <b-modal ref="myModalRefEcommerce" id="modalcenterEcommerce" centered title="Información preventiva" hide-footer modal-class="ew-modal">
            <p class="ew-modal__text">Has seleccionado un envío que ya ha sido pagado; te invitamos a desmarcar las casillas correspondientes para poder continuar con tu operación.</p>
            <div class="ew-modal__actions">
              <button class="ew-btn-primary" @click="hideModal">Entendido</button>
            </div>
        </b-modal>
      </b-tab>
    </b-tabs>
  </div>
</div>
</template>

<script>
import Navbar from './Header/Navbar'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import api from '../commons/api'
import axios from 'axios'
import commons from '../commons'
import PhIcon from './icons/PhIcon'


export default {
  name: 'Dashboard',
  data () {
    return {
      key:'',
      statusGuide:[],
      message:"",
      dismissSecs: 5,
      dismissCountDown: 0,
      selected: [],
      currentPage: 1,
      searchByKeywordCriteria: '',
      guideStatusFilter: 'all',
      paquetes:'all',
      availableCarriers: [],
      selectedService: 'Servicios',
      filterShipmentsTimeoutID: '',
      filter:[],
      dataLoading: true,
      services:{
        dhl:["EXPRESS DOMESTIC 10:30","EXPRESS DOMESTIC", "EXPRESS DOMESTIC DINAMICA", "EXPRESS DOMESTIC 12:00", "ECONOMY SELECT DOMESTIC","EXPRESS DOMESTIC FLAT", "SAMEDAY SPRINTLINE"],
        redpack:["ECOEXPRESS"],
        ampm: ["ESTANDAR", "EXPRESS"],
        estafeta: ["Envío Economico","Envío Express", "TERRESTRE", "DIA SIG"]
      }
    }
  },
  created () {
    this.setNewShipmentEcommerce(null);
    this.getUser()
    Tawk_API.onLoad = function(){
        Tawk_API.showWidget()
        Tawk_API.minimize()
    };
    this.getAllShipments().finally(() => { this.dataLoading = false })
    this.getMarketplace()
    this.getAvailableCarriers()
    this.$on('shipmentCreated', () => {
      this.getAllShipments()
    })
    setTimeout(() => {
      this.getAllShipments()
    }, 1500)

  },
  mounted(){
    try {
      Tawk_API.showWidget()
      Tawk_API.minimize()
    } catch (error) {

    }
  },
  beforeDestroy(){
    Tawk_API.hideWidget()
  },
  methods: {
    carrierAndServiceCarrier(serviceCarrier){
      if (this.services.dhl.includes(serviceCarrier)) {
        return `DHL - ${this.localCapitalize(serviceCarrier)}`
      } else if(this.services.redpack.includes(serviceCarrier)){
        return `Redpack - ${this.localCapitalize(serviceCarrier)}`
      } else if(this.services.ampm.includes(serviceCarrier)){
        return `AMPM - ${this.localCapitalize(serviceCarrier)}`
      }  else if(this.services.estafeta.includes(serviceCarrier)){
       return `Estafeta - ${this.localCapitalize(serviceCarrier)}`
      }
      else{
        return `Fedex - ${this.localCapitalize(serviceCarrier)}`
      }
    },
    statusShipments(){
      let status = false
      this.selected.forEach(element => {
          if (element.status) {
            status = true
          }
      });
      return status
    },
    showModal () {
      this.$refs.myModalRef.show()
    },
    hideModal () {
      this.$refs.myModalRef.hide()
    },
    localCapitalize(string){
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
    numberGuide(number, status, i){
      if (number !== null) {
        return number
      } else {
        return "Sin numero de guia"
      }
    },
    obtenerStatus(shipment)
    {
      if (shipment.number_guide == null) {
        return "Sin guía"
      }
      return shipment.tracking_status || "Sin verificar"
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    gotoShipmentDetails (id) {
      this.$router.push(`/shipments/${id}`)
    },
    gotoShipmentEcommerce(index){
      this.setNewShipmentEcommerce(this.marketplace[index]);
      this.$router.push(`/`)
    },
    previousPage () {
      axios.get(this.shipments.previous).then(response => {
        this.setShipments(response.data)
      })
    },
    nextPage () {
      axios.get(this.shipments.next).then(response => {
        this.setShipments(response.data)
      })
    },
    goToPage (page) {
      axios
        .get(
          `${commons.apiURL}/api/v1/shipments/all/${localStorage.getItem(
            'ew-user-id'
          )}?limit=10&page=${page}`
        )
        .then(response => {
          this.setShipments(response.data)
        })
    },
    availablePages (page) {
      const result = []
      let initial = page > 1 ? page - 1 : 1
      let final = page < this.shipments.pages ? page + 1 : this.shipments.pages

      for (let i = initial; i <= final; i++) {
        result.push(i)
      }

      return result
    },
    deletebadg(i){
      this.filter.splice(i, 1);
    },
    filterShipments (criteria) {
      this.filter.push(criteria)
      this.searchByKeywordCriteria = '';
    },
    filterShipmentsByGuideStatus (status) {
        this.filter.push(status)
    },
    getAvailableCarriers () {
      api.shipment
        .getAvailableCarriers(localStorage.getItem('ew-user-id'))
        .then(response => {
          this.availableCarriers = response.data

        })
        .catch(error => console.log(error))
    },
    filterShipmentsByCarriersServices (service) {
      this.filter.push(service)
    },
    downloadTracking (shipment) {
      if (shipment && shipment.guide && /^https?:\/\//i.test(shipment.guide)) {
        return shipment.guide
      }
      const id = shipment && shipment._id ? shipment._id : shipment
      return `https://www.enviosweb.com.mx/api/public/${id}.pdf`
    },
    duplicate(){
      var shipmentsSelected = [];
      this.selected.forEach((shipment)=>{
        delete shipment["_id"];
        shipment["status"] = false
        shipment["guide"] = ""
        shipment["number_guide"] = null
        shipment["reference"] = null
        shipment["customer_info"] = {first_names:this.user.firstName, last_names:this.user.lastName, email :this.user.email}
        shipmentsSelected.push(shipment)
      })

      axios.post(`${commons.apiURL}/api/v1/shipments/all`, { shipments: shipmentsSelected}).then((response)=>{
        this.selected = []
        this.getAllShipments()
        this.message ="Envios duplicados exitosamente."
        this.showAlert();
        console.log(response.data)
      }).catch(()=>{

      })

    },
    deleteMany(){
      var shipmentsSelected = [];
      this.selected.forEach((shipment)=>{
        shipmentsSelected.push(shipment._id)
      })

      axios.post(`${commons.apiURL}/api/v1/shipments/all/delete`, { list_id: shipmentsSelected}).then((response)=>{
        this.selected = []
        this.message ="Envios eliminados exitosamente."
        this.showAlert();
        this.getAllShipments()
      }).catch(()=>{

      })
    },
    pmeayntsMany(){

      if (this.statusShipments()) {
        this.showModal()
      } else {
        this.setPaymentShipments(this.selected)
        this.$router.push('/payment/shipments/many')
      }
    },
    filterIsTrue(array_filter){
      let status = true;
      array_filter.forEach(element => {
        if (!element) {
          status = false;
        }
      });
      return status;
    },
    getFilterStatus(items, shipment){
      let list_filter = [];
      items.forEach(item => {
          if (shipment.ecommerce_type === undefined) {

            if (shipment.destination_direction.full_name.toLowerCase().includes(item.toLowerCase())) {
              list_filter.push(true)
            } else if(shipment.destination_direction.address.toLowerCase().includes(item.toLowerCase())){
              list_filter.push(true)
            }else if(shipment.selected_service.carrier_service_name.includes(item)){
              list_filter.push(true)
            }else if(item.toLowerCase() == "true" || item.toLowerCase() === "false") {
              let guide = (item.toLowerCase() == 'true')?true:false
              if (shipment.status === guide) {
                list_filter.push(true)
              }else{
                list_filter.push(false)
              }
            }else{
              list_filter.push(false)
            }
          } else {
            if (shipment.destination_direction.full_name.toLowerCase().includes(item.toLowerCase())) {
              list_filter.push(true)
            } else if(shipment.destination_direction.address.toLowerCase().includes(item.toLowerCase())){
              list_filter.push(true)
            }else {
              list_filter.push(false)
            }
          }
        });
        return list_filter;
    },
    printBadge(text){
      if (text == "true" || text == "false" ) {
        return (text == 'true')?'Pagado':'Guia sin pago'
      } else {
        return text
      }
    },
    ...mapActions(['getAllShipments']),
    ...mapMutations(['setShipments']),
    ...mapActions(['getUser', 'getMarketplace']),
    ...mapMutations(["setPaymentShipments"]),
    ...mapMutations(['setNewShipmentEcommerce'])
  },
  computed: {
   ...mapGetters(['shipments', 'user', "paymentShipments", 'marketplace']),
    shipmentWithGuide () {
      return []
    },
    shipmentWithoutGuide () {
      return []
    },
    selectAll: {
            get: function () {
                return this.shipments ? this.selected.length == this.shipments.length : false;
            },
            set: function (value) {
                var selected = [];
                if (value) {
                    this.shipments.forEach(function (shipment) {
                        selected.push(shipment);
                    });
                }
                this.selected = selected;
            }
    },
    shipmentsFilter: function(){
      try {
        return this.shipments.filter((shipment)=>{
          return this.filterIsTrue(this.getFilterStatus(this.filter, shipment))
        });
      } catch (error) {
        console.log("this.shipments",this.shipments)
      }

    },
    marketplaceList: function(){
      if (this.key.length > 2) {
        return this.marketplace.filter((item)=>{
          let word = this.key.toLowerCase().trim()
          if(item.destination_direction.full_name.toLowerCase().trim().includes(word)) {
            return true
          }else{
            return false
          }
        })
      } else {
        return this.marketplace
      }

    }
  },
  components: {
    'navbar-dashboard': Navbar,
    PhIcon
  },
}
</script>

<style scoped lang="scss">
@import "../assets/styles/app-tokens";
@import "../assets/styles/ew-components";

.ew-page { @include app-tokens; }

.ew-page__body { padding: 1.75rem 2rem 2.5rem; }

/* Pestañas Envíos Web / E-Commerce ---------------------------------------- */
.ew-tabs {
  /deep/ .nav-pills {
    border-bottom: 1px solid var(--app-border);
    margin-bottom: 1.5rem;

    .nav-link {
      padding: 0.6rem 0.25rem;
      margin-right: 1.75rem;
      border-radius: 0;
      font-family: var(--app-font);
      font-size: 0.9rem;
      font-weight: 600;
      color: var(--app-muted);
      border-bottom: 2px solid transparent;

      &.active {
        color: var(--app-navy);
        background: transparent;
        border-bottom-color: var(--app-accent);
      }
    }
  }
}

.ew-toolbar {
  margin-bottom: 1rem;
  &.ew-toolbar--end { display: flex; justify-content: flex-end; }
}

.ew-alert {
  font-family: var(--app-font);
  border-radius: var(--app-radius-sm);
  margin-bottom: 1rem;
}

.ew-btn-primary { @include ew-btn-primary; }
.ew-btn-outline { @include ew-btn-outline; }

/* Tarjeta contenedora de la tabla ------------------------------------------ */
.ew-card { @include ew-card; margin-bottom: 2rem; }

.ew-filters {
  padding: 1.1rem 1.25rem;
  border-bottom: 1px solid var(--app-border);
}

.ew-filters__label {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.75rem;
  font-family: var(--app-font);
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--app-muted);

  svg { width: 0.9rem; height: 0.9rem; }
}

.ew-filters__row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.ew-input { @include ew-input; }
.ew-select { @include ew-select; }

.ew-filters__keyword { flex: 1 1 16rem; }
.ew-select { flex: 0 1 13rem; }

.ew-filters__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.9rem;
}

.ew-badge { @include ew-badge; }

.ew-bulk-actions {
  display: flex;
  gap: 0.6rem;
  margin-top: 1rem;
}

/* Tabla --------------------------------------------------------------------*/
.ew-table { @include ew-table; }
.ew-loading { @include ew-loading; }
.ew-loading-text { @include ew-loading-text; }
.ew-spinner { @include ew-spinner; }
.ew-table-row-clickable { @include ew-table-row-clickable; }

.ew-checkbox { @include ew-checkbox; }

.ew-table__amount {
  font-weight: 700;
  &.is-pending { color: var(--app-accent); }
  &.is-paid { color: #1a7f4f; }
}

.ew-table__pdf-link { display: inline-flex; }
.ew-table__link {
  color: var(--app-accent-button);
  font-weight: 700;
}

.ew-icon-pdf { width: 1.6rem; height: auto; }

.ew-empty { @include ew-empty; }
.ew-empty__title { @include ew-empty-title; }
.ew-empty__text { @include ew-empty-text; }

/* Paginación -----------------------------------------------------------------*/
.ew-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 1rem 1.25rem;
  border-top: 1px solid var(--app-border);
}

.ew-pagination__btn { @include ew-pagination-btn; }

/* Modal preventivo ----------------------------------------------------------*/
.ew-modal__text {
  font-family: var(--app-font);
  color: var(--app-navy-secondary);
  text-align: left;
}
.ew-modal__actions {
  display: flex;
  justify-content: flex-end;
}
</style>

<!-- El modal se monta fuera del árbol scoped; se estiliza aparte. -->
<style lang="scss">
@import "../assets/styles/app-tokens";

.ew-modal {
  .modal-content { border-radius: 0.85rem; border: none; }
  .modal-header { border-bottom: 1px solid $app-border; }
  .modal-title { font-family: $app-font-family; font-weight: 700; color: $app-navy; }
}
</style>



// WEBPACK FOOTER //
// src/components/ShipmentsList.vue